export const Category_ClinicalNote = 'clinical-note';
export const FHIR_DocumentReference_CategoryOptions = [
    Category_ClinicalNote,
];
export const FHIR_DocumentReference_CategoryOptions_ToLabelsMap = {
    [Category_ClinicalNote]: 'Clinical Note',
};
export const DocStatus_Preliminary = 'preliminary';
export const DocStatus_Final = 'final';
export const DocStatus_Amended = 'amended';
export const DocStatus_EnteredInError = 'entered-in-error';
export const FHIR_DocumentReference_DocStatusOptions = [
    DocStatus_Preliminary,
    DocStatus_Final,
    DocStatus_Amended,
    DocStatus_EnteredInError,
];
export const FHIR_DocumentReference_DocStatusOptions_ToLabelsMap = {
    [DocStatus_Preliminary]: 'Preliminary',
    [DocStatus_Final]: 'Final',
    [DocStatus_Amended]: 'Amended',
    [DocStatus_EnteredInError]: 'Entered In Error',
};
export const Type_DischargeDocumentation = '18842-5';
export const Type_Consultation = '11488-4';
export const Type_HistoryAndPhysical = '34117-2';
export const Type_ProgressNote = '11506-3';
export const Type_ProcedureNote = '28570-0';
export const Type_EmergencyDepartmentNote = '34111-5';
export const Type_NurseNote = '34746-8';
export const Type_DischargeInstructions = '74213-0';
export const Type_RiskAssessmentAndScreeningNote = '75492-9';
export const FHIR_DocumentReference_TypeOptions = [
    Type_DischargeDocumentation,
    Type_Consultation,
    Type_HistoryAndPhysical,
    Type_ProgressNote,
    Type_ProcedureNote,
    Type_EmergencyDepartmentNote,
    Type_NurseNote,
    Type_DischargeInstructions,
    Type_RiskAssessmentAndScreeningNote,
];
export const FHIR_DocumentReference_TypeOptions_ToLabelsMap = {
    [Type_DischargeDocumentation]: 'Discharge Documentation',
    [Type_Consultation]: 'Consultation',
    [Type_HistoryAndPhysical]: 'History & Physical',
    [Type_ProgressNote]: 'Progress Note',
    [Type_ProcedureNote]: 'Procedure Note',
    [Type_EmergencyDepartmentNote]: 'Emergency Department Note',
    [Type_NurseNote]: 'Nurse Note',
    [Type_DischargeInstructions]: 'Discharge Instructions',
    [Type_RiskAssessmentAndScreeningNote]: 'Risk assessment and screening note',
};
//# sourceMappingURL=consts.js.map